export const deliveryTimeSlots = {
    MORNING: "Horario de Mañana: 10 - 13 h.",
    AFTERNOON: "Horario de Tarde: 17 - 20 h."
};
